import { render, staticRenderFns } from "./transportAbnormalDetail.vue?vue&type=template&id=04988f7c"
import script from "./transportAbnormalDetail.vue?vue&type=script&lang=js"
export * from "./transportAbnormalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports